import { defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
/** @public */ export const localizelyProps = {
    apiKey: T.string
};
/** @internal */ export const localizelyLocalizationProviderMigrations = defineMigrations({});
export const LocalizelyLocalizationProviderInfo = {
    migrations: localizelyLocalizationProviderMigrations,
    props: localizelyProps
};
